import { useState } from "react";
import ExerciseLibrary from "@/components/ExerciseLibrary";
import WorkoutTemplates from "@/components/WorkoutTemplates";
import { BookOpen, ClipboardList } from "lucide-react";

export default function Treino() {
  const [section, setSection] = useState("library");

  return (
    <div>
      <h1 className="text-2xl sm:text-3xl font-bold font-heading text-slate-100 mb-1">Treino</h1>
      <p className="text-sm text-slate-400 mb-6">Monte sua biblioteca de exercícios e crie modelos de treino reutilizáveis.</p>

      <div className="flex gap-2 mb-6 bg-[#181F2C] border border-[#263147] rounded-2xl p-1.5 w-full sm:w-auto sm:inline-flex">
        <button data-testid="treino-tab-library" onClick={() => setSection("library")}
          className={`flex-1 sm:flex-none flex items-center justify-center gap-2 h-11 px-5 rounded-xl text-sm font-medium transition-colors ${
            section === "library" ? "bg-emerald-500 text-[#0A0D12]" : "text-slate-400 hover:text-slate-200"
          }`}>
          <BookOpen className="w-4 h-4" /> Biblioteca de Exercícios
        </button>
        <button data-testid="treino-tab-templates" onClick={() => setSection("templates")}
          className={`flex-1 sm:flex-none flex items-center justify-center gap-2 h-11 px-5 rounded-xl text-sm font-medium transition-colors ${
            section === "templates" ? "bg-emerald-500 text-[#0A0D12]" : "text-slate-400 hover:text-slate-200"
          }`}>
          <ClipboardList className="w-4 h-4" /> Modelos de Treino
        </button>
      </div>

      <div key={section}>
        {section === "library" ? <ExerciseLibrary /> : <WorkoutTemplates />}
      </div>
    </div>
  );
}
